import { useRef, useEffect } from "react";
import DOMPurify from "dompurify";
import { Bold, Italic, Underline, List, ListOrdered } from "lucide-react";

// Lightweight dependency-free rich text editor (contenteditable). Stores HTML.
export default function RichTextEditor({ value, onChange, placeholder, testId, rows = 3 }) {
  const ref = useRef();
  useEffect(() => {
    const clean = DOMPurify.sanitize(value || "");
    if (ref.current && ref.current.innerHTML !== clean) ref.current.innerHTML = clean;
  }, [value]);

  const exec = (cmd) => { document.execCommand(cmd, false, null); ref.current?.focus(); emit(); };
  const emit = () => onChange && onChange(DOMPurify.sanitize(ref.current?.innerHTML || ""));

  const Btn = ({ cmd, icon: Icon, label }) => (
    <button type="button" onMouseDown={(e) => { e.preventDefault(); exec(cmd); }} title={label}
      data-testid={`${testId}-${cmd}`} className="h-7 w-7 flex items-center justify-center rounded hover:bg-slate-200 text-slate-600">
      <Icon className="h-4 w-4" />
    </button>
  );

  return (
    <div className="rounded-md border bg-white focus-within:ring-1 focus-within:ring-brand-500">
      <div className="flex items-center gap-0.5 border-b px-1.5 py-1 bg-slate-50 rounded-t-md">
        <Btn cmd="bold" icon={Bold} label="Gras" />
        <Btn cmd="italic" icon={Italic} label="Italique" />
        <Btn cmd="underline" icon={Underline} label="Souligné" />
        <span className="w-px h-4 bg-slate-200 mx-1" />
        <Btn cmd="insertUnorderedList" icon={List} label="Liste à puces" />
        <Btn cmd="insertOrderedList" icon={ListOrdered} label="Liste numérotée" />
      </div>
      <div
        ref={ref}
        contentEditable
        suppressContentEditableWarning
        onInput={emit}
        data-placeholder={placeholder}
        data-testid={testId}
        style={{ minHeight: rows * 22 }}
        className="rte-content px-3 py-2 text-sm outline-none prose-sm max-w-none [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:list-decimal [&_ol]:pl-5 empty:before:content-[attr(data-placeholder)] empty:before:text-slate-400"
      />
    </div>
  );
}
